import { z } from 'zod';

export const IMAGE_TRANSFORMATION_ORIGIN = z
  .string()
  .parse(process.env.PUBLIC_IMAGE_TRANSFORMATION_ORIGIN);

export function getImageDpiPath(src: string, width: number, dpi: number) {
  if (IMAGE_TRANSFORMATION_ORIGIN === '') {
    return src;
  }

  return `${IMAGE_TRANSFORMATION_ORIGIN}/cdn-cgi/image/width=${
    width * dpi
  },dpi=${dpi}/${src}`;
}
